// extracted by mini-css-extract-plugin
export default {"predictionMain":"styles_predictionMain__+hcGx","status":"styles_status__Dyh1F"};